export default __webpack_public_path__ + "static/media/tiktok.d87798c1.svg";